import React, { useEffect, useState } from 'react';
import { requester } from 'App';
import BarChart from './chart/BarChart';
import DoughnutChart from './chart/DoughnutChart';
import PieChart from './chart/PieChart';
import LineChart from './chart/LineChart';
import DynamicTable from './top5/DynamicTable';
import SettlementStatus from './settlementComp/SettlementStatus';
import styles from './dashboard/VendorNewDashboard.module.css';
import { useNavigate } from 'react-router-dom';

function VendorSalesStatistics() {
    const [products, setProducts] = useState();
    const [isMounted, setMounted] = useState(false);
    const [salesData, setSalesData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            requester.getBestSalesTop5(result => {
                setProducts(result.data);
                console.log("result.data : ", result.data);
            });
            
            // 추가 데이터 로딩 (예시)
            requester.getWeeklyTotalSalesStatus({}, result => {
                if (result.data) {
                    setSalesData(result.data);
                }
            });
        }
    }, [isMounted]);

    return (
        <div className={styles.container}>
            <div className={styles.flexGrid}>
                {/* 상품별 판매량 차트 */}
                <div className={`${styles.flexBox} ${styles.wideBox}`}>
                    <div className={styles.card}>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>상품별 판매량</div>
                            <div className={styles.sectionContent}>
                                <BarChart productData={products && products} />
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* 판매량 순위 TOP 5 */}
                <div className={`${styles.flexBox}`}>
                    <div className={styles.card}>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>
                                <div className={styles.statsHeader}>
                                    <span>판매량 순위 TOP 5</span>
                                    {/* <span
                                        className={styles.moreLink}
                                        onClick={() => navigate('/vendor/products')}
                                    >
                                        더보기 {'>'}
                                    </span> */}
                                </div>
                            </div>
                            <div className={styles.sectionContent}>
                                <DynamicTable fetchedData={products && products} />
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* 매출 요약 */}
                <div className={`${styles.flexBox}`}>
                    <div className={styles.card}>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>매출 요약</div>
                            <div className={styles.sectionContent}>
                                <div className={styles.salesStatsCard}>
                                    <div className={styles.salesSummary}>
                                        <div className={styles.salesItem}>
                                            <span className={styles.salesLabel}>오늘 매출</span>
                                            <span className={styles.salesValue}>532,400원</span>
                                        </div>
                                        <div className={styles.salesItem}>
                                            <span className={styles.salesLabel}>이번주 매출</span>
                                            <span className={styles.salesValue}>14,826,600원</span>
                                        </div>
                                        <div className={styles.salesItem}>
                                            <span className={styles.salesLabel}>이번달 매출</span>
                                            <span className={styles.salesValue}>14,826,600원</span>
                                        </div>
                                        <div className={styles.salesItem}>
                                            <span className={styles.salesLabel}>올해 매출</span>
                                            <span className={styles.salesValue}>15,218,600원</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VendorSalesStatistics;
